import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber',
  standalone: true
})
export class PhoneNumberPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (!value) return value; //if no value, return what was passed in

    //return the value formatted as a phone number to our specs 
    return value.toString().replace(value.toString(), value.toString().substring(0,3) + "-" + value.toString().substring(3,6) + "-" + value.toString().substring(6,10));
  }

}
